import { Drawer } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import { useSwipeable } from 'react-swipeable';
import { ModalCloseIcon } from '../../../../../assets/icons/common/common-icons';
import { CheckboxCheckmarkIcon, ProcessingIcon, CompleteIcon } from './icons';
import {
    AllTagsWrapper,
    DrawerBody,
    DrawerCloseButton,
    DrawerHeader,
    DrawerTitle,
    DrawerWrapper,
    TagOption,
    TagOptionContent,
    TagOptionIcon,
    TagSection,
    TagSectionTitle
} from '../../VaultMetadataPanel/MetadataLabelsSection/TagsTagCategory/TagEditorDrawer.styles';

const statusOptions = [
    {
        id: 'Processing',
        label: 'In progress',
        description: 'Files are in deep analysis process, this might take up to 24h.',
        type: 'processing',
        color: '#F1F3F5'
    },
    {
        id: 'Done',
        label: 'Completed',
        description: 'Deep analysis process has completed and your portfolio was updated.',
        type: 'complete',
        color: '#72E1AC'
    }
];

export const StatusFilterDrawer = observer(({
    isOpen,
    onClose,
    selectedStatuses = [],
    onStatusSelect,
}) => {

    const swipeHandlers = useSwipeable({
        onSwipedDown: () => onClose(),
        trackMouse: false
    });

    const isStatusSelected = (statusId) => {
        return selectedStatuses.some(status => status.id === statusId || status === statusId);
    };

    const handleStatusClick = (status) => {
        onStatusSelect(status.id, status.label);
    };

    const renderStatusIcon = (status) => {
        if (status.type === 'processing') {
            return <ProcessingIcon />;
        } else {
            return (
                <span style={{
                    width: '16px',
                    height: '16px',
                    backgroundColor: status.color,
                    borderRadius: '50%',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <CompleteIcon />
                </span>
            );
        }
    };

    return (
        <Drawer
            closable={false}
            visible={isOpen}
            height={'auto'}
            placement="bottom"
            onClose={onClose}
            className="tag-editor-drawer-mobile"
            destroyOnClose={true}
        >
            <DrawerWrapper {...swipeHandlers}>
                <DrawerHeader>
                    <DrawerTitle>Status</DrawerTitle>
                    <DrawerCloseButton onClick={onClose}>
                        <ModalCloseIcon />
                    </DrawerCloseButton>
                </DrawerHeader>

                <DrawerBody>
                    <TagSection>
                        <TagSectionTitle>Status</TagSectionTitle>
                        <AllTagsWrapper>
                            {statusOptions.map((status) => (
                                <div key={status.id} style={{ marginBottom: '12px' }}>
                                    <TagOption onClick={() => handleStatusClick(status)}>
                                        <TagOptionContent>
                                            <TagOptionIcon style={{ 
                                                width: '20px', 
                                                height: '20px', 
                                                border: '2px solid #9097A3',
                                                borderRadius: '4px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: isStatusSelected(status.id) ? '#1A1B1D' : 'transparent'
                                            }}>
                                                {isStatusSelected(status.id) && <CheckboxCheckmarkIcon />}
                                            </TagOptionIcon>
                                            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '4px' }}>
                                                <div style={{ 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    gap: '8px',
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    color: '#1A1B1D'
                                                }}>
                                                    {renderStatusIcon(status)}
                                                    {status.label}
                                                </div>
                                                <div style={{ 
                                                    fontSize: '14px',
                                                    color: '#6B7280',
                                                    lineHeight: '1.4'
                                                }}>
                                                    {status.description}
                                                </div>
                                            </div>
                                        </TagOptionContent>
                                    </TagOption>
                                </div>
                            ))}
                        </AllTagsWrapper>
                    </TagSection>
                </DrawerBody>
            </DrawerWrapper>
        </Drawer>
    );
}); 